import store from 'store'

export default class CrudBuilder {
  constructor (mapper) {
    this.mapper = mapper
  }

  build (join) {
    return this.buildUrl(join)
  }

  buildUrl (join) {
    let routeParams = []
    let curr = null
    const regex = /\{([^)]+)\}/
    const current = store.getters['session/getCurrent']
    const session = store.getters['session/getSession']
    this.mapper.forEach(element => {
      curr = regex.exec(element.api)
      if (curr) {
        switch (curr[1]) {
          case 'idazi':
            routeParams.push(element.api.replace(regex, current.company.id))
            break
          case 'ambito':
            routeParams.push(element.api.replace(regex, session.ambito))
            break
        }
      } else {
        routeParams.push(element.api)
      }
    })
    return join ? routeParams.join('/') : routeParams
  }
}
